import { DocumentEmailModel } from '@/types/models/document/DocumentEmailModel';
import { DocumentEmailToMeModel } from '@/types/models/document/DocumentEmailToMeModel';
import axios from 'axios';

const ApiUrl = 'documentemail/';

export const DocumentEmailService = {
  async emailDocumentAsync(model: DocumentEmailModel, convertToPdf: boolean = false): Promise<void> {
    const response = await axios.post(ApiUrl, model, { params: { convertToPdf } });
    return response.data;
  },
  async emailDocumentToMeAsync(model: DocumentEmailToMeModel): Promise<void> {
    const response = await axios.post(`${ApiUrl}emailToMe`, model);
    return response.data;
  }
};
